import { createSvgIcon } from "@mui/material/utils";

export const PauseEndPlayIcon = createSvgIcon(
  <svg
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 16.6998V8.2998L11 12.4998L5 16.6998ZM13 16.4998V8.4998H15V16.4998H13ZM17 16.4998V8.4998H19V16.4998H17Z"
      fill="#5F6368"
    />
  </svg>,
  "PauseEndPlay"
);
